import type { Option } from '@branchjs/neo-components';
import type { Action } from 'redux';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';

const UpdateCampaign = new ReduxAsyncAction<'UPDATE_CAMPAIGN', Option, { campaign: Option }>('UPDATE_CAMPAIGN');

UpdateCampaign.registerRequest(async (campaign: Option) => {
  return { campaign };
});

export const UPDATE_CAMPAIGN = UpdateCampaign.actionNamespaceConstants;
export const updateCampaign = UpdateCampaign.request;

export type UpdateCampaignResponseAction = Action<typeof UPDATE_CAMPAIGN.response> & {
  data: { campaign: Option };
};
